import { useState } from 'react';
import { Menu, MenuItem } from './Menu';
 
const pages = [
  { to:'/',             label: 'Home' },
  { to:'/treatments',   label:"Treatments" },
  { to:'/rates',        label:"Rates" },
  { to:'/appointments', label: "Appointments" },
  { to:'/policies',     label: "Policies" },
  { to:'/reviews',      label: "Reviews" },
  { to:'/benefits',     label: "Benefits" },
  { to:'/about',        label: "About" }
]

export function Header(){
  const [ path, setPath ] = useState(window.location.pathname)
  return (
    <header className="App-header">
      <Menu onClick={ () => setPath(window.location.pathname) }>
        {
          pages.map(({ to, label }) => {
            return (
              <MenuItem
                key={to}
                to={to}
                label={label} 
                selected={path === to}   
              />
            );
          })
        }
      </Menu>
    </header>
  );
}